import React, { useEffect, useState, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  tooltip: {
    position: 'relative',
    backgroundColor: '#fff',
    color: '#4c4c4c',
    fontSize: 12,
    padding: '10px 14px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  popper: {
    '&[data-popper-placement*="bottom"] $tooltip::after': {
      top: '-5px',
      left: `50%`,
      transform: 'translateX(-50%)',
      borderWidth: '0 6px 6px 6px',
      borderColor: 'transparent transparent #fff transparent',
    },
    '&[data-popper-placement*="top"] $tooltip::after': {
      bottom: '-5px',
      left: `50%`,
      transform: 'translateX(-50%)',
      borderWidth: '6px 6px 0 6px',
      borderColor: '#fff transparent transparent transparent',
    },
    '&[data-popper-placement*="right"] $tooltip::after': {
      left: '-5px',
      top: `50%`,
      transform: 'translateY(-50%)',
      borderWidth: '6px 6px 6px 0',
      borderColor: 'transparent #fff transparent transparent',
    },
    '&[data-popper-placement*="left"] $tooltip::after': {
      right: '-5px',
      top: `50%`,
      transform: 'translateY(-50%)',
      borderWidth: '6px 0 6px 6px',
      borderColor: 'transparent transparent transparent #fff',
    },
  },
}));

function ArrowTooltip(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(props.open ? true : false);
  const containerRef = useRef();
  const tooltipContentRef = useRef();

  const handleOutsideClick = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      tooltipContentRef.current &&
      !tooltipContentRef.current.contains(event.target)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [open]);

  const handleMouseEnter = () => setOpen(true);
  const handleMouseLeave = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.relatedTarget) &&
      tooltipContentRef.current &&
      !tooltipContentRef.current.contains(event.relatedTarget)
    ) {
      setOpen(false);
    }
  };

  const handleIconClick = () => setOpen(true);

  return (
    <div
      ref={containerRef}
      onClick={handleIconClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ display: 'inline-block', position: 'relative' }}
    >
      <Tooltip
        classes={{ tooltip: classes.tooltip, popper: classes.popper }}
        placement={props.placement || 'top'}
        open={open}
        title={
          <div
            ref={tooltipContentRef}
            style={{ pointerEvents: 'auto' }} // Ensure pointer events on content
            dangerouslySetInnerHTML={{ __html: props.title }}
          />
        }
        onClose={() => setOpen(false)}
      >{props.children}</Tooltip>
    </div>
  );
}
  

export default ArrowTooltip;
